import React from 'react';

/**
 * DayCell Component
 * Individual day cell in the calendar grid
 * Supports week selection highlighting for bulk actions
 */
const DayCell = ({ 
    date, 
    meals = [], 
    isToday = false, 
    isPast = false,
    isSelected = false,
    isInSelectedWeek = false,
    onClick 
}) => {
    const dayNumber = date.getDate();
    const hasMeals = meals.length > 0;

    // Get pixel art icon for recipe indicator
    // User will provide icons in /images/menuScheduling/ folder
    // For now, use simple indicators - will be replaced with actual pixel art icons when provided

    return (
        <div
            className={`
                aspect-square 
                hairline 
                cursor-pointer 
                transition-all 
                duration-120
                flex flex-col
                relative
                ${isToday ? 'ring-2 ring-[#1b263b]' : ''}
                ${isSelected ? 'bg-neutral-50' : ''}
                ${isInSelectedWeek ? 'bg-[#f0f4f8]' : 'bg-neutral-0'}
                ${isPast ? 'opacity-50' : ''}
                hover:bg-neutral-50
            `}
            style={{
                boxShadow: 'none',
                transition: 'box-shadow 120ms ease-in-out, background-color 120ms ease-in-out'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '4px 4px 0px 0px rgba(0,0,0,0.25)';
                e.currentTarget.style.transform = 'translate(0, 0)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translate(0, 0)';
            }}
            onClick={onClick}
        >
            {/* Date number - top left */}
            <div className={`
                absolute top-1 left-1
                font-mono 
                text-sm 
                font-medium
                ${isToday ? 'text-[#1b263b]' : 'text-neutral-900'}
                ${isPast ? 'opacity-60' : ''}
            `}>
                {dayNumber}
            </div>

            {/* Scheduled recipes - shown inside the day card */}
            {hasMeals && (
                <div className="flex-1 flex flex-col justify-center items-start px-2 pt-6 pb-1 gap-1 overflow-hidden">
                    {meals.slice(0, 2).map((meal, index) => (
                        <div 
                            key={meal.id || index}
                            className="w-full flex items-center gap-1"
                        >
                            {/* Pixel art icon */}
                            <img
                                src={`/images/menuScheduling/${['tomato_icon.png', 'lemon_icon.png', 'spinach_icon.png'][index % 3]}`}
                                alt=""
                                className="w-3 h-3 flex-shrink-0"
                                style={{ 
                                    imageRendering: 'pixelated',
                                    imageRendering: '-moz-crisp-edges',
                                    imageRendering: 'crisp-edges'
                                }}
                            />
                            {/* Recipe name */}
                            <span className="font-sans text-xs text-neutral-900 truncate">
                                {meal.recipe_name || 'Scheduled recipe'}
                            </span>
                        </div>
                    ))}
                    {meals.length > 2 && (
                        <div className="text-xs font-mono text-neutral-900 opacity-60">
                            +{meals.length - 2} more
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default DayCell;

